import { render } from "./new-instruction-consignee.vue?vue&type=template&id=012c03cb&scoped=true"
import script from "./new-instruction-consignee.vue?vue&type=script&lang=js"
export * from "./new-instruction-consignee.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./new-instruction-consignee.vue?vue&type=style&index=1&id=012c03cb&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012c03cb"]])

export default __exports__